let hasScrolled = false;

function initLogoSlider() {
    var testimonialSlider = new Swiper('[data-testmonial-slider]', {
        loop: true,
        centeredSlides: true,
        spaceBetween: 100,
        centeredSlidesBounds: true,
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true
        },
        navigation: {
            nextEl: '.testimonial-next',
            prevEl: '.testimonial-prev',
          },
        breakpoints: {
            0: {
                spaceBetween: 50,
                slidesPerView: 1
            },
            990: {
                spaceBetween: 100,
                slidesPerView: 3
            }
          }
      });
}

window.addEventListener('scroll', function () {
    if (hasScrolled) return;
    if (window.scrollY > 100) {
        loadCSS(swiperCSS);
        loadJS(swiperJS)
            .then(() => initLogoSlider())
            .catch(error => console.error(error));
        hasScrolled = true;
    }
});